import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Particles = () => {
  const particles = Array.from({ length: 18 }, (_, i) => ({
    id: i,
    size: Math.random() * 10 + 5,
    left: Math.random() * 100,
    duration: Math.random() * 12 + 8,
    delay: Math.random() * 8,
    color: ['#87CEEB', '#B8E4F5', '#ffffff', '#5BB8D4', '#d6f0ff'][Math.floor(Math.random() * 5)],
  }));

  return (
    <div className="particles">
      {particles.map(p => (
        <div
          key={p.id}
          className="particle"
          style={{
            width: p.size,
            height: p.size,
            left: `${p.left}%`,
            bottom: '-20px',
            background: p.color,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
};

const WelcomeScreen = ({ onEnter }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  return (
    <div className="welcome-screen">
      <Particles />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        style={{ position: 'relative', zIndex: 1 }}
      >
        <div className="welcome-emoji">🎂</div>

        <h1 className="welcome-title">
          Happy Birthday<br />
          <span>KP</span>
        </h1>

        <div className="welcome-divider" />

        <p className="welcome-message">
          Readyyy girlll??? 🎁
        </p>

        <motion.button
          className="welcome-btn"
          onClick={onEnter}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.6 }}
        >
          Open Your Gifts 🎀
        </motion.button>
      </motion.div>
    </div>
  );
};

export default WelcomeScreen;
